import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	description: {
		color: colors.gray[700],
		fontWeight: 400,
		fontSize: "20px",
		lineHeight: "30px"
	},
	eventTrigger: {
		color: colors.getPrimaryColor(),
		fontWeight: 500
	},
	descriptionTrigger: {
		color: colors.gray[700],
		fontWeight: 600,
		fontSize: "24px"
	},
	title: {
		fontSize: "32px",
		lineHeight: "24px",
		color: colors.gray[700]
	},
	buttonPrimaryColorOutLined: {
		border: "1px solid",
		boxShadow: "none",
		borderColor: "rgba(126, 13, 214, 0.12)",
		fontWeight: 500,
		...ColorUtil.getBackgroundAndContrastColor("transparent"),
		color: colors.getPrimaryColor(),
		letterSpacing: 0.4,
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor("transparent"),
			boxShadow: "none"
		}
	},
	textAlert: {
		marginTop: "17px",
		paddingTop: "18px",
		paddingBottom: "18px"
	},
	chatBotTabIndicator: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor())
	},
	chatBotTab: {
		color: `${colors.gray[700]} !important`,
		opacity: 1,
		fontSize: 14
	},
	chatBotTabs: {
		width: "100%",
		position: "relative",
		"&::before": {
			content: "close-quote",
			position: "absolute",
			width: "100%",
			height: "1px",
			bottom: 0,
			left: 0,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		}
	},
	subtitleText: {
		color: colors.getPrimaryColor(),
		fontWeight: 400,
		fontSize: "20px",
		lineHeight: "30px"
	},
	chatBotChip: {
		height: "20px",
		width: "103px",
		fontSize: "14px",
		fontWeight: 600,
		lineHeight: "24px",
		textAlign: "center",
		color: colors.gray[0]
	},
	disableSelection: { "& > *": { pointerEvents: "none" } }
}))

export default useStyles
